import styled from 'styled-components';

export const TextAreaContainer = styled.div`
  margin-bottom: 44px;
  .ant-form-item textarea.ant-input {
    resize: none;
    height: 134px;
  }
`;
